import { all } from "redux-saga/effects";
import AppSaga from "./app-sagas";
import PricingSaga from "./pricing/pricing-saga";

export default function* rootSagas() {
  yield all([AppSaga(), PricingSaga()]);
}
